import React, { useState, useEffect } from 'react';

const RelativeTime = ({ date, className = '' }) => {
  const [relativeTime, setRelativeTime] = useState('');

  const getRelativeTime = (dateString) => {
    let publishDate;
    
    if (dateString) {
      publishDate = new Date(dateString);
      if (isNaN(publishDate.getTime())) {
        publishDate = new Date(parseInt(dateString));
      }
    } else {
      publishDate = new Date();
    }
    
    const now = new Date();
    const diffInMs = now.getTime() - publishDate.getTime();
    const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
    const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    const isDateOnly = dateString && !dateString.includes(':') && !dateString.includes('T');
    const isToday = publishDate.toDateString() === now.toDateString();
    
    if (isDateOnly && isToday) {
      return 'Just now';
    }
    
    if (diffInMinutes < -60 || (diffInMinutes > 24 * 60 && isDateOnly)) {
      return publishDate.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric'
      });
    }

    if (diffInMinutes < 1) {
      return 'Just now';
    } else if (diffInMinutes < 60) {
      return `${diffInMinutes} minute${diffInMinutes === 1 ? '' : 's'} ago`;
    } else if (diffInHours < 24) {
      return `${diffInHours} hour${diffInHours === 1 ? '' : 's'} ago`;
    } else {
      // After 24 hours, show full date format: OCTOBER 29, 2025 12:30 PM
      return publishDate.toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
      }).toUpperCase() + ' ' + publishDate.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      });
    }
  };

  useEffect(() => {
    const updateTime = () => {
      setRelativeTime(getRelativeTime(date));
    };

    updateTime();
    const interval = setInterval(updateTime, 30000); // Update every 30 seconds

    return () => clearInterval(interval);
  }, [date]);
  
  // Update when page becomes visible
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        setRelativeTime(getRelativeTime(date));
      }
    };
    
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [date]);

  return <span className={className}>{relativeTime}</span>;
};

export default RelativeTime;